var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.themeType === 0)?_c('span',{staticClass:"btn",class:{ active: _vm.collected },attrs:{"data-io-click":"tracker"},on:{"click":_vm.collectHandle}},[_c('i',{staticClass:"iconfont",class:[
      _vm.collected ? 'icon-' + _vm.activeIconClass : 'icon-' + _vm.defaultIconClass,
    ]}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.collected ? "已收藏" : "收藏"))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }